import { createAsyncThunk } from '@reduxjs/toolkit';

import { setReferralCode } from '@/modules/driver/actions/actions';
import { driverAPI } from '@/modules/driver/api';
import { IReferralCode } from '@/modules/driver/model/referral-code';
import { namespace } from '@/modules/driver/namespace';

const loadReferralCode = createAsyncThunk(
  `${namespace}/load-referral-code`,
  async (_, { dispatch }): Promise<IReferralCode | undefined> => {
    try {
      const referralCode = await driverAPI.fetchReferralCode();

      dispatch(setReferralCode(referralCode));

      return referralCode;
    } catch {
      return undefined;
    }
  },
);

export { loadReferralCode };
